// Flowchart.js
import React from 'react'
import styled from 'styled-components'
import Step from './Step'

const FlowchartContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 20px;
  padding: 20px;
  border-radius: 5px;
  width: 100%;
`

export function FlowChart({ rodizio }) {
  return (
    <FlowchartContainer>
      <Step
        label="Cliente novo?"
        content={rodizio.cliente_novo === 'N' ? 'Não' : 'Sim'}
        nextStep
      />
      <Step
        label="Entrou no rodízio?"
        content={rodizio.entrou_rodizio === 'S' ? 'Sim' : 'Não'}
        nextStep
      />
      <Step
        label="Por onde entrou?"
        content={rodizio.origem_contato}
        nextStep
        third
      />
      <Step
        label="Conflito de vendedores?"
        content={rodizio.conflito_vendedores === 'N' ? 'Não' : 'Sim'}
        nextStep
        secondLine
      />
      <Step
        label="Pendência do vendedor no momento do fluxo"
        content={`${rodizio.pendencias_vendedor} pendências`}
        secondLine
        nextStep
      />
      <Step
        label="O Vendedor estava ativo na fila?"
        content={rodizio.ativo_fila === 'S' ? 'Sim' : 'Não'}
        secondLine
      />
    </FlowchartContainer>
  )
}
